import { render, staticRenderFns } from "./add-competency.vue?vue&type=template&id=4d5dbf99&scoped=true&"
import script from "./add-competency.ts?vue&type=script&lang=ts&"
export * from "./add-competency.ts?vue&type=script&lang=ts&"
import style0 from "./add-competency.scss?vue&type=style&index=0&id=4d5dbf99&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5dbf99",
  null
  
)

export default component.exports